// Per-browser Global Search "Favorites" - lets a user pin eligible QUICK_LINKS
// entries (index.js's QUICK_LINKS array) for one-click access. Local only, no
// backend - same storage convention as recentSearchStore.js, own key so it
// never mixes with Recent/Recently Viewed.
//
// Stores favorited QUICK_LINKS *labels* (not routes) - labels are already the
// stable key QUICK_LINKS entries are looked up by elsewhere in index.js (see
// resolveRecentIcon's quickLink lookup), and routes can carry query params
// that would make dedup/lookup fragile.
//
// Scoped per company + user, same reasoning as recentSearchStore.js /
// recentlyViewedStore.js - a shared/public browser never leaks one person's
// favorites to the next person who logs in.
import { getGlobalSearchKeySuffix } from "./globalSearchStorageKey";

const MAX_FAVORITES = 15;

const getStorageKey = () => `globalSearch.favorites.${getGlobalSearchKeySuffix()}`;

export const getFavorites = () => {
  try {
    const raw = localStorage.getItem(getStorageKey());
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch (e) {
    return [];
  }
};

export const isFavorite = (label) => !!label && getFavorites().includes(label);

// Adds `label` if it isn't already favorited, removes it if it is. Returns
// the resulting list so callers can sync their own state in one call.
export const toggleFavorite = (label) => {
  if (!label) return getFavorites();
  try {
    const existing = getFavorites();
    const next = existing.includes(label)
      ? existing.filter((item) => item !== label)
      : [label, ...existing].slice(0, MAX_FAVORITES);
    localStorage.setItem(getStorageKey(), JSON.stringify(next));
    return next;
  } catch (e) {
    // Private browsing / storage blocked - fail soft, Favorites is a nice-to-have.
    return getFavorites();
  }
};
